// extracted by mini-css-extract-plugin
export default {"tasks":"gP-z","task":"hP-z","svg":"iP-z","text":"jP-z"};